var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3601 12.73C19.9901 12.73 19.6801 12.45 19.6401 12.08C19.4001 9.88001 18.2201 7.90001 16.4001 6.64001C16.0701 6.41001 15.9901 5.96001 16.2201 5.63001C16.4501 5.30001 16.9001 5.22001 17.2301 5.45001C19.4001 6.96001 20.8001 9.32001 21.0901 11.93C21.1301 12.33 20.8401 12.69 20.4401 12.73C20.4101 12.73 20.3901 12.73 20.3601 12.73Z",
    fill: "#017EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74004 12.78C3.72004 12.78 3.69004 12.78 3.67004 12.78C3.27004 12.74 2.98004 12.38 3.02004 11.98C3.29004 9.37002 4.67004 7.01002 6.82004 5.49002C7.14004 5.26002 7.60004 5.34002 7.83004 5.66002C8.06004 5.99002 7.98004 6.44002 7.66004 6.67002C5.86004 7.95002 4.69004 9.93002 4.47004 12.12C4.43004 12.5 4.11004 12.78 3.74004 12.78Z",
    fill: "#017EA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9901 21.1C14.7601 21.69 13.4401 21.99 12.0601 21.99C10.6201 21.99 9.2501 21.67 7.9701 21.02C7.6101 20.85 7.4701 20.41 7.6501 20.05C7.8201 19.69 8.2601 19.55 8.6201 19.72C9.2501 20.04 9.9201 20.26 10.6001 20.39C11.5201 20.57 12.4601 20.58 13.3801 20.42C14.0601 20.3 14.7301 20.09 15.3501 19.79C15.7201 19.62 16.1601 19.76 16.3201 20.13C16.5001 20.49 16.3601 20.93 15.9901 21.1Z",
    fill: "#017EA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 2.01001C10.5 2.01001 9.22998 3.27001 9.22998 4.83001C9.22998 6.39001 10.49 7.65001 12.05 7.65001C13.61 7.65001 14.87 6.39001 14.87 4.83001C14.87 3.27001 13.61 2.01001 12.05 2.01001Z",
    fill: "#017EA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04998 13.87C3.49998 13.87 2.22998 15.13 2.22998 16.69C2.22998 18.25 3.48998 19.51 5.04998 19.51C6.60998 19.51 7.86998 18.25 7.86998 16.69C7.86998 15.13 6.59998 13.87 5.04998 13.87Z",
    fill: "#017EA7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9499 13.87C17.3999 13.87 16.1299 15.13 16.1299 16.69C16.1299 18.25 17.3899 19.51 18.9499 19.51C20.5099 19.51 21.7699 18.25 21.7699 16.69C21.7699 15.13 20.5099 13.87 18.9499 13.87Z",
    fill: "#017EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f41619a42cda244147ca8d43e9cb138c.svg";
export { ForwardRef as ReactComponent };